<div class="drawer-table-wrapper">
  <nz-table
    #notificationSettings
    [nzData]="(listOfData$ | async) ?? []"
    [nzLoading]="loading$ | async"
    [nzScroll]="{ x: '700px', y: 'calc(100vh - 290px)' }"
    [nzShowPagination]="false">
    <thead>
      <tr>
        <th nzWidth="70%" [title]="listOfColumn[0].title">
          {{ listOfColumn[0].title }}
        </th>
        <th nzWidth="15%" [title]="listOfColumn[1].title">
          {{ listOfColumn[1].title }}
        </th>
        <th nzWidth="15%" [title]="listOfColumn[2].title">
          {{ listOfColumn[2].title }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of notificationSettings.data">
        <td>
          <ng-container *ngIf="data.description.includes('XX')">
            <span>{{ data.description.split('XX')[0] }}</span>
            <ng-container
              *ngIf="!!selectedOrganizationId; else editableThreshold">
              <span class="admin-only-value">{{ data.thresholdDays }}</span>
            </ng-container>
            <ng-template #editableThreshold>
              <nz-input-number
                [ngModel]="data.thresholdDays"
                (ngModelChange)="updateThreshold(data, $event)"
                (blur)="onBlurThreshold(data, data.thresholdDays)"
                [nzMin]="1"
                [nzMax]="data.type === 'Subscription Expiry Reminder' ? 90 : 10"
                [nzDisabled]="loading$ | async"
                [nzSize]="'small'"
                style="width: 60px"></nz-input-number>
            </ng-template>
            <span>{{ data.description.split('XX')[1] }}</span>
          </ng-container>
          <ng-container *ngIf="!data.description.includes('XX')">
            {{ data.description }}
          </ng-container>
        </td>
        <td>
          <nz-switch
            *ngIf="data.isAdminOnly || selectedOrganizationId"
            [(ngModel)]="data.inApp"
            (ngModelChange)="toggleInAppNotification(data)"
            [nzLoading]="loading$ | async" />
        </td>
        <td>
          <nz-switch
            *ngIf="data.isAdminOnly || selectedOrganizationId"
            [(ngModel)]="data.inEmail"
            (ngModelChange)="toggleEmailNotification(data)"
            [nzLoading]="loading$ | async" />
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
